import type { ApiResponse } from '../types';
import routes from '@/config/routes';
import { v3Get } from '@/api/axios.instance.V3';

const getCampaignsById = (Client: number | null | undefined): ApiResponse =>
  v3Get(`${routes.backendUrl.campaigns.getByClientId + Client}`);

const getCampaignsStatus = (Client: number | null | undefined): ApiResponse =>
  v3Get(`${routes.backendUrl.campaigns.getCampaignStats + Client}`);

export const campaignsApi = {
  getCampaignsById,
  getCampaignsStatus,
};
